import type { Board } from '@brigh-am/black-hole-board/game';
import type { Hint } from './useSolverHints';

export type HintStage = 0 | 1 | 2 | 3;

/** Scores are from the mover's perspective. Partial results cannot identify a best move. */
export function verifiedBestCell(board: Board, hints: ReadonlyMap<string, Hint>, pending: boolean): string | undefined {
    if (pending || board.isGameOver()) return undefined;
    const legal: string[] = [];
    for (let row = 0; row < board.rows; row++) {
        for (let col = 0; col <= row; col++) {
            if (board.at(row, col) === 0) legal.push(`${row}-${col}`);
        }
    }
    if (hints.size !== legal.length || legal.some(key => !Number.isFinite(hints.get(key)?.value))) return undefined;
    return legal.reduce((best, key) => hints.get(key)!.value > hints.get(best)!.value ? key : best);
}

export function ruleHint(board: Board): string {
    if (board.cellCount - board.filled === 2) {
        return 'Try examining the two possible black holes. Your final piece fills one space; the other swallows its neighbors. Compare how many points each player would lose.';
    }
    if (board.filled < 3) {
        return 'Try examining the spaces touching your next piece. Any space left empty at the end could swallow that piece. Both players use the same numbers, so only placement changes the result.';
    }
    return 'Try examining the empty spaces beside your biggest pieces. The last empty space swallows its neighbors. A piece is safe once every neighboring space is filled.';
}
